// YELLOW BRICK WATERMARK
console.log('%c Made by YELLOW BRICK TECH. (UK) 🧱', 'padding: 10px; background: #f5d448; color: #333; font-weight: bold; border-left: 3px solid #333; border-radius: 3px;');

import 'core-js/stable'; import 'regenerator-runtime/runtime';

import config from './config/config';
window.env = config;
Vue.prototype.$env = config;
window.config = config;
Vue.prototype.$config = config;

Vue.prototype.$whitelabel = process.env['VUE_APP_WHITELABEL'];
if(Vue.prototype.$whitelabel === 'false') {
  Vue.prototype.$whitelabel = false;
}

import Lodash from 'lodash'; window._ = Lodash;
import './config/prefs';

import vueToPdf from 'vue-to-pdf'

Vue.use(vueToPdf)

import Vue from 'vue'
import App from './App.vue'
import Notifications from 'vue-notification'
import VueClickOutside from 'v-click-outside'
import VueInputAutowidth from 'vue-input-autowidth'
import VueFilterDateFormat from 'vue-filter-date-format';

import report_nutrients from '@/views/report/assets/nutrients.mockup';
const reportNutrients = report_nutrients;

import * as VueGoogleMaps from 'vue2-google-maps'

import UI from './components/ui'
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'

import './styles/main.scss'

import router from './router'
import store from './store'
import axios from 'axios'

import './lang/lang';

import VueSocialauth from 'vue-social-auth'

Vue.use(VueSocialauth, {
 
  providers: {
    google: {
      clientId: '537977884857-737t9c0luj3i1co0so7foa5gvvfr04ta.apps.googleusercontent.com',
      client_secret: '1qSBdVeM3r6h0p2U380nndL_',
      redirectUri: 'https://app.smart-dev.co.uk/auth/google/callback'
    }
  }
})


Vue.use(VueClickOutside)
Vue.use(Notifications);
Vue.use(UI);

Vue.use(VueInputAutowidth);
Vue.use(VueFilterDateFormat);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDQ_7sO-ZxjAZSHQXCUtVdQdHeWIytBy5I',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    language: 'en',
  },
});

// this part resolve an issue where the markers would not appear (leaflet)
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$storage_url = process.env['VUE_APP_SERVICE_API_URL'];

Vue.prototype.$interpretationChart = function(lvl) {
  switch(lvl) {
    case 'Excessive': 
      return '#EC5A60';
    case 'High': 
      return '#F2B14E';
    case 'Adequate': 
      return '#A7B975';
    case 'Low': 
      return '#5EC19B';
    
  }
};

Vue.prototype.$sortNutrients = function (key) {
  
  const nutrients = reportNutrients.map(n => n.key);
  return (a, b) => {
    const a_index = nutrients.findIndex(n => n === a[key]);
    const b_index = nutrients.findIndex(n => n === b[key]);

    if (a_index < b_index) {
      return -1;
    }
    if (a_index > b_index) {
      return 1;
    }
    return 1;
  }
}

Vue.prototype.$renderCurrency = function () {
  return ' $';
}

Vue.prototype.$interpretationToLevel = function (interpret) {
  if(interpret == 'Excessive') {
    return 4;
  }
  else if(interpret == 'High') {
    return 3;
  }
  else if(interpret == 'Adequate') {
    return 2;
  }
  else if(interpret == 'Low') {
    return 1;
  }
  else {
    return 0;
  }
}

Vue.prototype.$levelToInterpretation = function (level) {
  if(level == 4) {
    return 'Excessive';
  }
  else if(level == 3) {
    return 'High';
  }
  else if(level == 2) {
    return 'Adequate';
  }
  else if(level == 1) {
    return 'Low';
  }
}

Vue.prototype.$renderUnit = function (unit_id) {
  const units = {
    '0': 'ml/m3',
    '1': 'l/m3',
    '2': 'gr/m3',
    '3': 'gr/m3',
    '4': 'litres',
    '5': 'litres',
    '6': 'kg',
    '7': 'kg',
  };

  return units[unit_id];
}

import CheckBox from '@/views/report/components/common/CheckBox';
import HeadLine from '@/views/report/components/common/HeadLine';
import MainHeader from '@/views/report/components/common/MainHeader';

Vue.component('check-box', CheckBox);
Vue.component('head-line', HeadLine);
Vue.component('main-header', MainHeader);

window.app = new Vue({
  router,
  store,
  data: {
    FUCKTHISLOAD: false,
    AAAAAAAAAAAAAA: '',
  },
  render: h => h(App)
}).$mount('#app')
